"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _styles = require("@material-ui/styles");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _moment = _interopRequireDefault(require("moment"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _clsx = _interopRequireDefault(require("clsx"));

var _DynamicForm = _interopRequireDefault(require("../../DynamicForm"));

var _utils = _interopRequireDefault(require("../../../utils/utils"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      diaplay: "flex",
      flex: 1
    },
    btnContainer: {
      border: "1px dashed #BDBDBD",
      borderRadius: 15,
      height: 70,
      display: "flex",
      alignItems: "center",
      marginBottom: 20,
      cursor: "pointer"
    },
    btnContainerGray: {
      backgroundColor: "#F2F2F2",
      border: "none",
      fontWeight: 500
    },
    flexMargin: {
      marginLeft: 20,
      display: "flex",
      alignItems: "center"
    },
    text: {
      fontSize: 12
    },
    btnFooter: {
      marginLeft: "2%",
      marginRight: "2%"
    }
  };
});

var Segment = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 2em 0.5em;\n"])));

var Wizard = function Wizard(_ref) {
  var _field$childs;

  var field = _ref.field,
      previousStep = _ref.previousStep,
      firstStep = _ref.firstStep,
      nextStep = _ref.nextStep,
      activeStep = _ref.activeStep,
      handleBack = _ref.handleBack,
      handleNext = _ref.handleNext,
      totalSteps = _ref.totalSteps,
      isValid = _ref.isValid,
      currentStep = _ref.currentStep,
      isValidCustomValidation = _ref.isValidCustomValidation,
      isAdvance = _ref.isAdvance,
      advanceCount = _ref.advanceCount,
      sortedDefinition = _ref.sortedDefinition,
      setActiveStep = _ref.setActiveStep,
      dataAdvance = _ref.dataAdvance,
      handleDataAdvance = _ref.handleDataAdvance,
      setIndex = _ref.setIndex,
      handleResetForm = _ref.handleResetForm,
      redirect = _ref.redirect;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      utility = _useState2[0],
      setUtility = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      currentForm = _useState4[0],
      setCurrentForm = _useState4[1];

  var isDesktop = _utils.default.isDesktop();

  var getCurrentElements = function getCurrentElements() {
    if (!currentForm.length) {
      var formElements = document.querySelectorAll("#step-".concat(currentStep, " .react-grid-item"));
      setCurrentForm(formElements);
    }
  };

  (0, _react.useEffect)(function () {
    var formElements = document.querySelectorAll("#step-".concat(currentStep, " .react-grid-item"));
    setCurrentForm(formElements);
  }, [activeStep]);
  var childs = (_field$childs = field.childs) === null || _field$childs === void 0 ? void 0 : _field$childs.map(function (res) {
    res.inside = true;
    return res;
  });

  var isDisableByDependency = function isDisableByDependency(disableDependencyTargetId) {
    var storedAnswers = JSON.parse(localStorage.getItem("storedAnswers")) || [];
    var result = false; //todo: cambiar el valor 0 por el valor que se espera ahora es un valor customizado

    if (storedAnswers && storedAnswers.length) {
      result = storedAnswers.find(function (item) {
        return item.fieldId === disableDependencyTargetId && item.value == 0;
      }); //encuentra el componente del cual depende y ve si esta en negativo "0"
    }

    return !!result;
  };

  var isValidNew = (0, _react.useCallback)(function () {
    var filteredFields = [];

    if ((childs === null || childs === void 0 ? void 0 : childs.length) > 0) {
      filteredFields = childs === null || childs === void 0 ? void 0 : childs.map(function (f) {
        var age = null;
        if (f.elementType === "date") age = (0, _moment.default)().diff(f.value, "years");

        if (f.elementType === "radio" && f.required && f.value === "default" || f.elementType === "checkbox" && f.required && (f.value === "default" || !_utils.default.existSomeCheckboxInTrue(f.elementType === "checkbox" ? f.attributes : [])) || !f.allowNull && f.value === "" && f.elementType !== "checkbox" || !f.allowNull && f.value === "+" && f.elementType !== "checkbox" || f.elementType === "date" && !f.allowNull && f.value === null || f.elementType === "date" && f.isBirthday && age < 18 || f.customValidation && !isValidCustomValidation(f, f.value)) {
          if (!isDisableByDependency(f.disableDependency)) {
            f.hasError = true;
          } else {
            f.hasError = false;
          }
        } else {
          f.hasError = false;
        }

        return f;
      });
    }

    return filteredFields.some(function (f) {
      return f.hasError;
    });
  }, [childs, isValidCustomValidation]);
  (0, _react.useEffect)(function () {
    var hasErr = childs === null || childs === void 0 ? void 0 : childs.some(function (child) {
      return child.hasError;
    });

    if (!utility && hasErr) {
      setUtility(!utility);
    }
  }, [childs, utility]);

  var nextOrSubmit = function nextOrSubmit() {
    isValid();
    if (isValidNew()) return;
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    nextStep();
    handleNext();
    setCurrentForm([]); //resest current node elements for calculate next btn position
  };

  var resetStep = function resetStep() {
    setActiveStep(0);
    firstStep();
  };

  var getTraslateYPosition = function getTraslateYPosition(node) {
    return node.style.getPropertyValue("transform").match(/(-?[0-9\.]+)/g);
  };

  var getHighestPosition = function getHighestPosition(elements) {
    var extraTopMargin = 15;
    var highestPosition = 0;
    var nodeHighestPosition = undefined;
    var nodeHeight = 0;

    if (elements && elements.length) {
      elements.forEach(function (node) {
        var position = getTraslateYPosition(node);

        if (position && position.length) {
          position = parseInt(position[1]);
        }

        if (position && position > highestPosition) {
          highestPosition = position;
          nodeHighestPosition = node;
        }
      });
    } //obtener la altura del elemento en la posicion mas alta y sumarselo


    if (nodeHighestPosition) {
      nodeHeight = parseInt(nodeHighestPosition.scrollHeight);
    }

    return highestPosition + nodeHeight + extraTopMargin;
  }; // set style form and transform btns wizard


  (0, _react.useEffect)(function () {
    getCurrentElements();
    var element = document.getElementById(field.uid);
    var btn = document.getElementById("".concat(field.uid, "-btn"));
    var form = element === null || element === void 0 ? void 0 : element.querySelector(".react-grid-layout");

    if (!JSON.parse(isAdvance)) {
      btn.style.display = "none";

      if (isDesktop) {
        var height = getHighestPosition(currentForm);
        btn.style.transform = "translate(0px, ".concat(height, "px)");
      } else {
        if (!isDesktop && form && form.length) {
          form.forEach(function (node) {
            node.style.removeProperty("transform");
          });
        }

        btn.style.removeProperty("transform");
        btn.style.position = "relative";
      }

      form.appendChild(btn);
      btn.style.display = "flex";
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [field.uid, isDesktop, currentForm]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, field.uid === "step-0" && JSON.parse(isAdvance) ?
  /*#__PURE__*/
  // component custom button
  React.createElement(Segment, null, Array.from(new Array(Number(advanceCount))).map(function (_, i) {
    return /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return setIndex(i);
      }
    }, /*#__PURE__*/React.createElement(ElevationContainer, {
      key: i,
      nextOrSubmit: nextOrSubmit,
      dataAdvance: dataAdvance[i]
    }));
  })) : /*#__PURE__*/React.createElement("div", {
    id: field.uid
  }, /*#__PURE__*/React.createElement(_DynamicForm.default, {
    definition: childs,
    detail: false,
    editMode: true,
    formId: "",
    gridSize: "1" // por ahora dejar en 1, luego cambiar a la config del accordion.
    ,
    previewMode: true,
    inside: true
  })), /*#__PURE__*/React.createElement("div", {
    id: "".concat(field.uid, "-btn")
  }, /*#__PURE__*/React.createElement(_Button.default, {
    className: classes.btnFooter,
    variant: "outlined",
    disabled: activeStep === 0,
    onClick: function onClick() {
      previousStep();
      handleBack(currentStep - 1);
    }
  }, "Atr\xE1s"), /*#__PURE__*/React.createElement(_Button.default, {
    className: classes.btnFooter,
    type: activeStep > totalSteps ? "submit" : "button",
    variant: "contained",
    color: "primary",
    style: {
      backgroundColor: "#02183a"
    },
    onClick: function onClick() {
      activeStep >= totalSteps ? JSON.parse(isAdvance) ? resetStep() : nextOrSubmit() : nextOrSubmit(); // click Guardar familiar

      if (activeStep >= totalSteps && JSON.parse(isAdvance)) {
        var defFilter = sortedDefinition.filter(function (e) {
          return e.uid !== "step-0";
        });
        var gg = defFilter.map(function (r, i) {
          var obj = {};

          var _iterator = _createForOfIteratorHelper(r.childs),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var el = _step.value;
              obj.name = el.name;
              obj.value = el.value;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return obj;
        });
        handleDataAdvance(gg); // reset form

        handleResetForm(); // redirect

        if (!JSON.parse(isAdvance)) redirect();
      }
    }
  }, activeStep >= totalSteps ? JSON.parse(isAdvance) ? "Guardar familiar" : "Guardar" : "Siguiente")), JSON.parse(isAdvance) && activeStep === 0 && /*#__PURE__*/React.createElement(_Button.default, {
    type: "submit",
    variant: "contained",
    style: {
      width: "100%",
      marginTop: 40
    }
  }, "Siguiente"));
};

var ElevationContainer = function ElevationContainer(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(classes.btnContainer, props.dataAdvance && classes.btnContainerGray),
    onClick: function onClick() {
      return props.nextOrSubmit();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flexMargin
  }, !props.dataAdvance && /*#__PURE__*/React.createElement(_Add.default, {
    color: "primary"
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.text
  }, props.dataAdvance ? props.dataAdvance[0].value : "Agregar un familiar")));
};

var _default = Wizard;
exports.default = _default;